export const METHODS_IDS_WITH_LABEL = [226, 227];
